export default "__VITE_ASSET__CZfdcmua__"